module.exports = __webpack_public_path__ + "media/king-k-rool.e9346f69.wav";